import { URL } from ".";

const readCommit = async ({ token, commit_id }) => {
  try {
    const response = await fetch(`${URL}/commits/${commit_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`
      }
    });
    return await response.json();
  } catch (error) {
    console.log('Unable to read commit', error);
  }
}
const readUserCommits = async ({ token, user_id }) => {
  try {
    const response = await fetch(`${URL}/users/${user_id}/commits`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`
      }
    });
    return await response.json();
  } catch (error) {
    console.log('Unable to read user commmits', error);
  }
}

const readTeamCommits = async ({ token, team_id, start, end }) => {
  try {
    const response = await fetch(`${URL}/teams/${team_id}/commits?start=${start}&end=${end}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${token}`
      }
    });
    return await response.json();
  } catch (error) {
    console.log('Unable to read team commmits', error);
  }
}

export { readCommit, readUserCommits, readTeamCommits }
